import React, { createContext, useContext, useState } from 'react';
import { api } from 'app';

const DepositsUIContext = createContext();

export function useDepositsUIContext() {
  return useContext(DepositsUIContext);
}

export function DepositsUIProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = async input => {
    // remove "?" from query string
    const query = input.slice(1);

    api
      .get(`/adminPanel/deposits?include=depositable&${query}`)
      .then(response => {
        setData(response);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const value = {
    fetchData,
    data,
    setData,
    isLoading,
    setIsLoading
  };

  return <DepositsUIContext.Provider value={value}>{children}</DepositsUIContext.Provider>;
}
